import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=1a86a37a&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86a37a",
  null
  
)

export default component.exports